// "future-pro" behaves like "futures" (symbols, lot size, expiry, table columns).
// Differences: api url type is "future-pro", payload sends trade_type "Pro",
// and there is no parrva / instrument / entry_price_range.
export const FUTURES_TRADE_TYPES = ["futures", "future-pro"];

export const isFuturesType = (tradeType) => FUTURES_TRADE_TYPES.includes(tradeType);

// edit / cancel / exit url
export const getTradeUpdateUrl = (tradeType) =>
  tradeType === "future-pro"
    ? "/predictions/futures-pro-call-update/"
    : `/predictions/${tradeType}-call-update/`;

// cancelled-trades list url (only Future Pro has a separate Cancel tab)
export const CANCELLED_TRADES_URL = {
  "future-pro": "predictions/futures/cancel-pro",
};

// closed-trades list url
export const getClosedTradesUrl = (tradeType) =>
  tradeType === "future-pro" ? "predictions/futures/close-pro" : `predictions/${tradeType}/close`;
